import { mapGetters } from 'vuex';

const saleMixin = {
  computed: {
    ...mapGetters('contracts', ['getIOContractData']),
    ...mapGetters('accounts', ['isUserConnected']),
    preSaleEndDate() {
      return this.preSaleEpoch + 24 * 60 * 60 * 1000;
    },
    isPreSaleLive() {
      return !this.isUserConnected || !this.getIOContractData.hasPopulated
        ? Date.now() > this.preSaleEpoch && !this.hasPreSaleEnded
        : Date.now() > this.preSaleEpoch &&
            this.getIOContractData.isPreSaleLive &&
            !this.hasPreSaleEnded;
    },
    hasPreSaleEnded() {
      return Date.now() >= this.preSaleEndDate;
    },
    isPublicSaleLive() {
      return !this.isUserConnected || !this.getIOContractData.hasPopulated
        ? Date.now() > this.publicSaleEpoch
        : this.getIOContractData.isPublicSaleLive;
    },
    preSaleEpoch() {
      return parseInt(process.env.VUE_APP_PRE_SALE_EPOCH);
    },
    publicSaleEpoch() {
      // SC is using seconds, JS uses ms, thus need to * 1000
      return !this.isUserConnected || !this.getIOContractData.hasPopulated
        ? parseInt(process.env.VUE_APP_PUBLIC_SALE_EPOCH)
        : parseInt(this.contractData.publicSaleStartTime) * 1000;
    },
    noSaleStarted() {
      return !this.isPreSaleLive & !this.isPublicSaleLive;
    },
    preSaleLocalTime() {
      return this.epochToLocalTime(process.env.VUE_APP_PRE_SALE_EPOCH);
    },
    publicSaleLocalTime() {
      return this.epochToLocalTime(process.env.VUE_APP_PUBLIC_SALE_EPOCH);
    },
  },
  methods: {
    epochToLocalTime(epoch) {
      const epochDateTime = new Date(parseInt(epoch));

      return `${epochDateTime.toLocaleDateString('en-US', {
        day: 'numeric',
      })} ${epochDateTime.toLocaleDateString('en-US', {
        month: 'short',
      })} ${epochDateTime.toLocaleDateString('en-US', {
        year: 'numeric',
      })} ${epochDateTime.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
      })} (Local Time)`;
    },
  },
};

export default saleMixin;
